import React from 'react';
import { DatePicker as AntDatePicker } from 'antd-v5';
import clearImg from '@/common/images/clear.png';
import './style.less';
function DatePicker(props) {
  const { allowClear = true, className, dropdownClassName, ...nativeProps } = props;

  return (
    <AntDatePicker
      {...nativeProps}
      className={`ui-date-picker ${className}`}
      dropdownClassName={`ui-date-picker-dropdown ${dropdownClassName}`}
      allowClear={
        allowClear
          ? {
              clearIcon: <img src={clearImg} alt='clear' style={{ width: 16, height: 16 }} />,
            }
          : false
      }
    />
  );
}
function RangePicker(props) {
  const { allowClear = true, className, dropdownClassName, ...nativeProps } = props;
  return (
    <AntDatePicker.RangePicker
      {...nativeProps}
      className={`ui-date-picker ${className}`}
      dropdownClassName={`ui-date-picker-dropdown ${dropdownClassName}`}
      allowClear={
        allowClear
          ? {
              clearIcon: <img src={clearImg} alt='clear' style={{ width: 16, height: 16 }} />,
            }
          : false
      }
    />
  );
}
DatePicker.RangePicker = RangePicker;
DatePicker.MonthPicker = AntDatePicker.MonthPicker;
DatePicker.WeekPicker = AntDatePicker.WeekPicker;
DatePicker.TimePicker = AntDatePicker.TimePicker;
DatePicker.YearPicker = AntDatePicker.YearPicker;
DatePicker.QuarterPicker = AntDatePicker.QuarterPicker;
DatePicker.HalfYearPicker = AntDatePicker.HalfYearPicker;
DatePicker.DecadePicker = AntDatePicker.DecadePicker;
export default DatePicker;
